import { DatePipe } from '@angular/common';
import { Component, OnInit, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { Subject } from "rxjs";
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DateObject, Document_Upload_File, GM_APP, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { GrantsSummaryService } from "src/app/services/grants/grants-summary.service";
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, tap } from 'rxjs';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { Router } from '@angular/router';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { FileService } from 'src/app/services/file.service';
import { UserService } from 'src/app/services/user.service';
import * as _ from 'lodash';



@Component({
  selector: 'app-grants-delivery-format',
  templateUrl: './grants-delivery-format.component.html',
  styleUrls: ['./grants-delivery-format.component.scss']
})
export class GrantsDeliveryFormatComponent implements OnInit,IDeactivateComponent {
  formFields;
  stateOptions = [];
  staticformFields: any;
  currentFormattype: any;
  countryOptions = [];
  disabledDates: Date [] = [];
  therapeuticAreaOptions:any = []
  MeetingOptions = [];
  deliveryFormatForm: UntypedFormGroup;
  deliveryFormatOptions: any = [];
  content: any;
  therapeuticAreas$: Observable<any>;
  heading: string;
  minDate1 : Date
  minDate2 : Date
  WebminDate1 : Date
  WebminDate2 : Date
  LiveminDate1 : Date
  LiveminDate2 : Date
  ReleaseDate : Date
  ExpiryDate : Date
  StartDate = new Date();
  EndDate = new Date();
  WebStartDate: Date;
  WebEndDate : Date;
  action: Subject<any> = new Subject();
  //grantsapp: GM_APP;
  permission: string;
  //ApplicationID: any;
  maxReleaseDate: Date | undefined;
  minReleaseDate = new Date();
  maxExpiryDate: Date | undefined;
  minExpiryDate = new Date();
  minstartDate = new Date();
  maxStartDate: Date | undefined;
  minEndDate = new Date();
  maxEndDate: Date | undefined;
  appid: string;
  IsOptProcessOptions: any = [];
  operations: any = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  IsFormToched:boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: string;
  submittedresponse: SCREEN_RESPONSE[] = [];
  isSubmitVisible : boolean = false;
  disableSave: boolean = false;
  Grantsapp: any;
  createdUser: any;
  ScreenSubmitStatus: boolean = false;
  user : any;
  submitStatus:boolean = false;
  Id : string;
  status : number = 0;
  GeneralInformationFields: any;
  Application_Type_ID: string = "";
  ScreenName: string = '';
  Currency_ID: string = '';

  constructor(
    private router: Router,
    private summaryService: GrantsSummaryService,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private DatashareSerivce: GrantsDatashareService,
    public datepipe: DatePipe,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService,
    public fileService: FileService,
    private userService: UserService,
  ) {
    this.setFormPermissions();
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.grantsDatashare.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.grantsDatashare.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.GetParentScreenFieldsConfigControls('GC01');
    //this.NavigateToGenInfo();
    this.Grantsapp = this.commonService.getGrantsApp();
    this.user = this.userService.getUserDetais();
    this.appid = this.commonService.appId;
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.appid = x;
    });
    this.GetScreenConfigControls("SCR-024");  

    if(!this.isSubmitVisible){
      this.disableSave = false;
    }
    
    this.permission = this.commonService.getPagePermission("GC03").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("GC03").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          clearInterval(intervalId);
          this.setFormPermissions();
        }
      }, 1000);
    }
    else {
      this.setFormPermissions();
    }
   // this.getTherapeuticAreaList();

     
    //this.fecthdeliveryformat();
   
    // this.commonService.getGlobalDirtyInfo().subscribe((res)=>{
    //   if(res==true){
    //     this.deliveryFormatForm.markAsPristine();
    //      this.extendedForm.IsFormToched=false;
    //   }
    // });
  }
  private setFormPermissions() {
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
    }


    if (this.permission == "view") {
      this.operations = [];
    }
    else {
      this.operations = [
        {
          name: 'Save', type: 'submit', callback: this.save, self: this
        }
      ];
    }
  }

  
  onCallbackOperation(opr) {
    opr.callback();
  }

  getSelectedValue(event: any): void {
this.deliveryFormatForm.controls["WEB"].reset();
this.deliveryFormatForm.controls["ENDURING_MATERIAL"].reset();
this.deliveryFormatForm.controls["LIVE"].reset();

  }

  private fecthdeliveryformat() {

    let today = new Date();
    today.setHours(0,0,0,0);
    let date1: Date;  let date2: Date;

    this.summaryService
      .getDeliveryFormatSummary(this.Grantsapp.ID,this.appid)
      .subscribe((result) => {
        if (result != null) {
          this.therapeuticAreaOptions = result.TherapeuticAreaList;
          this.therapeuticAreaOptions = [{ label: "Select", value: null, checked: true }].concat(this.therapeuticAreaOptions);
          this.MeetingOptions = [{ label: "Select", value: null }].concat(result.MeetingTypeList);
          this.deliveryFormatOptions = [{ label: "Select", value: null }].concat(result.FormatTypeList);
          if (
            result.ENDURING_MATERIAL == null &&
            result.LIVE == null &&
            result.WEB == null
          ) {
            this.deliveryFormatForm.patchValue({
              ID: result.ID || "",
              APPLICATION_ID: result.APPLICATION_ID || "",
              THERAPEUTIC_AREA_ID: result.THERAPEUTIC_AREA_ID || null,
              FORMAT_TYPE_ID: result.FORMAT_TYPE_ID || null,
              MEETING_TYPE_ID: result.MEETING_TYPE_ID || null,
            });
          } else {
            if ( result.LIVE != null) {
              if (
                (result.LIVE.START_DATE != null &&
                  result.LIVE.START_DATE != "" &&
                  result.LIVE.START_DATE != undefined)
              ) {
                result.LIVE.START_DATE= this.commonService.getdisplayedDate(result.LIVE.START_DATE);
                this.StartDate = result.LIVE.START_DATE;
                date1 = new Date(this.StartDate);
                // setTimeout(() => {
                //   while (date1 < today) {
                //     this.disabledDates.push(new Date(date1));
                //     date1.setDate(date1.getDate() + 1);
                //   }
                // }, 1000);
                // if (this.StartDate < today && this.StartDate != null)
                //   this.minDate1 = this.StartDate; 
                // else this.minDate1 = today

              }
              if (
                result.LIVE.END_DATE != null &&
                result.LIVE.END_DATE != "" &&
                result.LIVE.END_DATE != undefined
              ) {
                result.LIVE.END_DATE = this.commonService.getdisplayedDate(result.LIVE.END_DATE);
                this.EndDate = result.LIVE.END_DATE;

                date2 = new Date(this.EndDate)
                // setTimeout(() => {
                //   while (date2 < today) {
                //     this.disabledDates.push(new Date(date2));
                //     date2.setDate(date2.getDate() + 1);
                //   }
                // }, 1000);

                // if (this.EndDate < today && this.EndDate != null)
                //   this.minDate2 = this.EndDate; 
                // else this.minDate2 = today
              }
            }
            if ( result.WEB != null){
              if (
                result.WEB.START_DATE != null &&
                result.WEB.START_DATE != "" &&
                result.WEB.START_DATE != undefined
              ) {
                result.WEB.START_DATE = this.commonService.getdisplayedDate(result.WEB.START_DATE);
                this.WebStartDate = result.WEB.START_DATE;

                date1 = new Date(this.WebStartDate)
                // setTimeout(() => {
                //   while (date1 < today) {
                //     this.disabledDates.push(new Date(date1));
                //     date1.setDate(date1.getDate() + 1);
                //   }
                // }, 1000);
                
                // if (this.WebStartDate < today)
                //   this.minDate1 = this.WebStartDate;
                //  else this.minDate1 = today
              }
              if (
                result.WEB.END_DATE != null &&
                result.WEB.END_DATE != "" &&
                result.WEB.END_DATE != undefined
              ) {
                result.WEB.END_DATE = this.commonService.getdisplayedDate(result.WEB.END_DATE);
                this.WebEndDate = result.WEB.END_DATE;
                date2 = new Date(this.WebEndDate);
                // setTimeout(() => {
                //   while (date2 < today) {
                //     this.disabledDates.push(new Date(date2));
                //     date2.setDate(date2.getDate() + 1);
                //   }
                // }, 1000);
                // if (this.WebEndDate < today)
                //   this.minDate2 = this.WebEndDate; 
                // else this.minDate1 = today
              }
            }
                     //Enduring Material Delivery Format type Dates
            if (result.ENDURING_MATERIAL != null){
              if (
                result.ENDURING_MATERIAL.RELEASE_DATE != null &&
                result.ENDURING_MATERIAL.RELEASE_DATE != "" &&
                result.ENDURING_MATERIAL.RELEASE_DATE != undefined
              ) {
                result.ENDURING_MATERIAL.RELEASE_DATE = this.commonService.getdisplayedDate(result.ENDURING_MATERIAL.RELEASE_DATE);
                this.ReleaseDate =result.ENDURING_MATERIAL.RELEASE_DATE;

                  date1 = new Date(this.ReleaseDate)
                  // setTimeout(() => {
                  //   while (date1 < today) {
                  //     this.disabledDates.push(new Date(date1));
                  //     date1.setDate(date1.getDate() + 1);
                  //   }
                  // }, 1000);
                  // if (result.ENDURING_MATERIAL.RELEASE_DATE < today)
                  //     this.minDate1 = this.ReleaseDate;
                  //   else  this.minDate1 = today;
              }
              if (
                result.ENDURING_MATERIAL.EXPIRY_DATE != null &&
                result.ENDURING_MATERIAL.EXPIRY_DATE != ""  &&
                result.ENDURING_MATERIAL.EXPIRY_DATE != undefined
              ) {
                // result.ENDURING_MATERIAL.EXPIRY_DATE = this.datepipe.transform(
                //   result.ENDURING_MATERIAL.EXPIRY_DATE,
                //   'dd-MMM-yyyy'
                // );
                result.ENDURING_MATERIAL.EXPIRY_DATE = this.commonService.getdisplayedDate(result.ENDURING_MATERIAL.EXPIRY_DATE);
                this.ExpiryDate = result.ENDURING_MATERIAL.EXPIRY_DATE;

                 date2 = new Date(this.ExpiryDate)
                      // setTimeout(() => {
                      //   while (date2 < today) {
                      //     this.disabledDates.push(new Date(date2));
                      //     date2.setDate(date2.getDate() + 1);
                      //   }
                      // }, 1000);
                      // if (this.ExpiryDate < today)
                      //   this.minDate2 = this.ExpiryDate; 
                      //   else  this.minDate2 = today
                }
          }
          
            this.deliveryFormatForm.patchValue({
              ID: result.ID || "",
              APPLICATION_ID: result.APPLICATION_ID || "",
              THERAPEUTIC_AREA_ID: result.THERAPEUTIC_AREA_ID || null,
              FORMAT_TYPE_ID: result.FORMAT_TYPE_ID || null,
              MEETING_TYPE_ID: result.MEETING_TYPE_ID || null,
              ENDURING_MATERIAL: {
                IS_OPT_IN_PROCESS:
                  result.ENDURING_MATERIAL.IS_OPT_IN_PROCESS || null,
                RELEASE_DATE: result.ENDURING_MATERIAL.RELEASE_DATE || null,
                EXPIRY_DATE: result.ENDURING_MATERIAL.EXPIRY_DATE || null,
                TRANSFER_MODE: result.ENDURING_MATERIAL.TRANSFER_MODE || ""
              },
              LIVE: {
                NO_OF_FACULTIES: result.LIVE.NO_OF_FACULTIES || null,
                START_DATE: result.LIVE.START_DATE || null,
                END_DATE: result.LIVE.END_DATE || null,
                ADDRESS: result.LIVE.ADDRESS || "",

              },
              WEB: {
                NO_OF_FACULTIES: result.WEB.NO_OF_FACULTIES || null,
                START_DATE: result.WEB.START_DATE,
                END_DATE: result.WEB.END_DATE,
                WEB_URL: result.WEB.WEB_URL,
              }

            });
          }
          this.currentFormattype = result.FORMAT_TYPE_ID;
          this.extendedForm.rowid = result.ID;
          this.extendedForm.getResponse();
        }
        this.deliveryFormatForm.markAsPristine();

      });
  }
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid).subscribe((result) => {
      this.staticformFields = result["Data"];
      this.IsOptProcessOptions =
        this.staticformFields["IS_OPT_IN_PROCESS"].GROUP_VALUES_LIST;
      this.MeetingOptions =
        this.staticformFields["MEETING_TYPE_ID"].GROUP_VALUES_LIST;
      this.MeetingOptions = [{ label: "Select", value: null }].concat(
        this.MeetingOptions);
        this.deliveryFormatOptions = this.staticformFields["FORMAT_TYPE_ID"].GROUP_VALUES_LIST;
        this.deliveryFormatOptions = [{ label: "Select", value: null }].concat(
          this.deliveryFormatOptions);
          if(this.staticformFields.RELEASE_DATE.IS_PASTDATES_ALLOWED)
            {this.minDate1 = new Date(); this.minDate1.setHours(0,0,0,0) } 
          else this.minDate1 = null;
          if(this.staticformFields?.EXPIRY_DATE.IS_PASTDATES_ALLOWED)
          {  this.minDate2 = new Date(); this.minDate2.setHours(0,0,0,0) }
          else this.minDate2 = null 

          if(this.staticformFields?.LIVE_START_DATE?.IS_PASTDATES_ALLOWED)
           { this.LiveminDate1 = new Date(); this.LiveminDate1.setHours(0,0,0,0)}
          else this.LiveminDate1 = null
          if(this.staticformFields?.LIVE_END_DATE?.IS_PASTDATES_ALLOWED)
            {this.LiveminDate2 = new Date(); this.LiveminDate2.setHours(0,0,0,0)}
          else this.LiveminDate2 = null

          if(this.staticformFields?.WEB_START_DATE?.IS_PASTDATES_ALLOWED)
         {   this.WebminDate1 = new Date(); this.WebminDate1.setHours(0,0,0,0)}
          else this.WebminDate1 = null
          if(this.staticformFields?.WEB_END_DATE.IS_PASTDATES_ALLOWED)
             { this.WebminDate2 = new Date(); this.WebminDate2.setHours(0,0,0,0) }
          else this.WebminDate2 = null
    });
  }

  //Delivery format type Enduring_Material Date Objects
  Full_Release_Date: DateObject;
  Full_Expiry_Date: DateObject;
  isreleaseDateModified: boolean = false;
  isexpiryDateModified: boolean = false;

  ReleaseDateSelect(event) {
    this.maxReleaseDate = event;
    this.isreleaseDateModified = true;
    this.Full_Release_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isreleaseDateModified,
    };
  }
  ExpiryDateSelect(event) {
    this.maxExpiryDate = event;
    this.isexpiryDateModified = true;
    this.Full_Expiry_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isexpiryDateModified,
    };
  }
  GetReleaseDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.ENDURING_MATERIAL.RELEASE_DATE);
    if ((
      this.CompareDates(this.ReleaseDate, lDate) ||
      this.Full_Release_Date == null ||
      this.Full_Release_Date == undefined) && formModel.ENDURING_MATERIAL.RELEASE_DATE != null 
    ) {
      this.Full_Release_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    this.Full_Release_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true,
    };
    return this.Full_Release_Date;
  }
  GetExpiryDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.ENDURING_MATERIAL.EXPIRY_DATE);
    if ((
      this.CompareDates(this.ExpiryDate, lDate) ||
      this.Full_Expiry_Date == null ||
      this.Full_Expiry_Date == undefined) && formModel.ENDURING_MATERIAL.EXPIRY_DATE != null
    ) {
      this.Full_Expiry_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_Expiry_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_Expiry_Date;
  }

  //LIVE Date Objects
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  isstartDateModified: boolean = false;
  isendDateModified: boolean = false;

  startDateSelect(event) {
    this.maxStartDate = event;
    this.isstartDateModified = true;
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isstartDateModified,
    };
  }
  EndDateSelect(event) {
    this.maxEndDate = event;
    this.isendDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isendDateModified,
    };
  }
  GetLiveStartDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.LIVE.START_DATE);
    if ((
      this.CompareDates(this.StartDate, lDate) ||
      this.Full_Start_Date == null ||
      this.Full_Start_Date == undefined) && formModel.LIVE.START_DATE != null
    ) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true,
    };
    return this.Full_Start_Date;
  }
  GetLiveEndDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.LIVE.END_DATE);
    if ((
      this.CompareDates(this.EndDate, lDate) ||
      this.Full_End_Date == null ||
      this.Full_End_Date == undefined) && formModel.LIVE.END_DATE != null 
    ) {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_End_Date;
  }

  //Deliveryformattype - WEB  Date Objects

  GetWebStartDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.WEB.START_DATE);
    if ((
      this.CompareDates(this.WebStartDate, lDate) ||
      this.Full_Start_Date == null ||
      this.Full_Start_Date == undefined )&& formModel.WEB.START_DATE != null 
    ) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_Start_Date;
  }
  GetWebEndDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.WEB.END_DATE);
    if ((
      this.CompareDates(this.WebEndDate, lDate) ||
      this.Full_End_Date == null ||
      this.Full_End_Date == undefined)&& formModel.WEB.END_DATE != null
    ) {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };}
      else{
        this.Full_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: false,
          HasValue: true,
          IsDateModified: true,
        };
    }

    return this.Full_End_Date;
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {
      let oDt =
        olddate.getDate().toString() +
        olddate.getMonth().toString() +
        olddate.getFullYear().toString();
      let nDt =
        newDate.getDate().toString() +
        newDate.getMonth().toString() +
        newDate.getFullYear().toString();
      if (oDt == nDt) {
        return true;
      } else {
        return false;
      }
    } else return false;
  }

  // getTherapeuticAreaList() {
  //   this.summaryService
  //     .getTherapeuticAreaList(this.grantsapp.ID)
  //     .subscribe((result) => {
  //       if (result != null) {
  //         this.therapeuticAreaOptions = result;
  //         this.therapeuticAreaOptions = [{ label: "Select", value: null, checked: true }].concat(this.therapeuticAreaOptions);
  //       }
  //     });
  // }   

  postalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getCity(value).subscribe((x) => {
        if (x.Status) {
          $("#CITY").val(x.Data.City);
          $("#PROVINCE").val(x.Data.StateFullName);
          $("#COUNTRY").val(x.Data.Country);
        }
      });
    } else {
      $("#CITY").val("");
      $("#PROVINCE").val("");
      $("#COUNTRY").val("");
    }
  }

  // save(SaveType:string) {

  //   if (this.validateControls()) {

  //     let formData = new FormData();
  //     formData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
  //     formData.append("Appid", this.ApplicationID);
  //     formData.append("ModuleID", "4");
  //     formData.append("SUBMIT_STATUS", "0");

  //     if(formData["Appid"] == null || formData["Appid"] == "" || formData["Appid"] == undefined ) {
  //       //insert
  //       this.summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', formData).subscribe((result) => {
  //         if (result.Status === 0) {
          
  //           this['self'].deliveryFormatForm.controls["ID"].setValue(result.TransactionID);
  //           this['self'].extendedForm.saveControls(result.TransactionID, result.Data, result.TransactionCode).subscribe(result1 => {
  //             if (result1.Status === 0) {
  //               this['self'].commonService.SuccessBanner(result.Message);
  //               this['self'].extendedForm.IsFormToched=false;
  //               this['self'].deliveryFormatForm.markAsPristine();
  //             }
  //             else {
  //               this['self'].commonService.ValidationBanner(result1.Message);
  //             }
  //           });
  //         }
  //         else{
  //           this['self'].commonService.ValidationBanner(result.Message);
  //         }

  //       });
  //     }
  //     else {
  //       //update
  //       this['self'].summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', formData).subscribe((summary) => {

  //         if (summary.Status === 0 || summary.ErrorCode === "NOCHANGES") {
  //           this['self'].extendedForm.saveControls(summary.TransactionID, summary.Data, summary.TransactionCode).subscribe(result => {
  //             if (result.ErrorCode === "NOCONTROLS") {
  //               if (summary.Status === 0)
  //               {
  //                 this['self'].commonService.SuccessBanner(summary.Message);
  //                 this['self'].extendedForm.IsFormToched=false;
  //                 this['self'].deliveryFormatForm.markAsPristine();
  //               }
                
  //               else {
  //                 this['self'].commonService.ValidationBanner(summary.Message);
  //               }
  //             }
  //             else {
  //               if (summary.ErrorCode === "NOCHANGES" && result.ErrorCode === "NOCHANGES") {
  //                 this['self'].commonService.ValidationBanner(summary.Message);
  //               } else {
  //                 if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
  //                   this['self'].extendedForm.rowid = summary.TransactionID;
  //                   this['self'].extendedForm.getResponse();
  //                   this['self'].extendedForm.IsFormToched=false;
  //                   this['self'].deliveryFormatForm.markAsPristine();
  //                 }
  //                 this['self'].commonService.SuccessBanner('Delivery Format saved successfully');
  //               }
  //             }
  //           });
  //         }
  //         else {
  //           this.commonService.ValidationBanner(summary.Message);
  //         }
  //       });
  //     }
  //   }
  // }

  save(SaveType:string) {

    if( SaveType == "Submit" && this.user.ID == this.createdUser){
      this.submitStatus = true;
    }
    if(!this.submitStatus){      
      return this.commonService.ValidationBanner("This screen is currently being worked on by another user. You are not permitted to make changes at this time.");
     }

    if (this.validateControls()) {
      for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();
        let FinalControls=_.cloneDeep(this.staticformFields);
        FinalControls.forEach((item)=>{
          switch (item.CONTROL) {
            case 10:
              item.ControlValue=null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("ModuleID", "4");

        if (SaveType == "Save") {
          if(this.isSubmitVisible == true && this.Grantsapp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
            uploadData.append("SUBMIT_STATUS", "0");

          } 
          else {
            uploadData.append("SUBMIT_STATUS", "1");
          }
        } else{
          uploadData.append("SUBMIT_STATUS", "1");

        }

      if(this.appid){
        if (this.appid == "" || this.appid == undefined) {
          uploadData.append("Appid", this.appid);
          this.summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', uploadData).subscribe((result) => {
            var tempID = result.Data;
            this.appid = result.Data;
            this.DatashareSerivce.setGrantApplicationID(tempID);
            this.getScreenDataEdit();
            this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
            this.commonService.refreshApplicationPage(this.appid,'grants');
          });
        }
        else {
            uploadData.append("Appid", this.appid);
            uploadData.append("RecordID",this.appid);
          this.summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', uploadData).subscribe((result) => {
            if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
              if (result.ErrorCode === "NOCHANGES"){
                    this.getScreenDataEdit();
                    this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.getScreenDataEdit();
                this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
              }
            }
            else {
              this.getScreenDataEdit();
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
      }
      else{
        this.SaveCME_GM_APP().subscribe((result) => {
          if (result != null && result.Status == 0) {
            this.appid = result["TransactionID"];
            this.grantsDatashare.setGrantApplicationID(this.appid);
            uploadData.append("Appid", this.appid);
            this.summaryService.SaveGrantInfo("api/gmdeliveryformat/insertdeliveryformat", uploadData).subscribe((summary) => {
              if (summary.Status === 0) {
                this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                this.commonService.refreshApplicationPage(this.appid, 'grants');
              }
              else {
                this.commonService.ValidationBanner(summary.Message);
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }
        })
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";

    if(this.Grantsapp?.STATUS >= 2){
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 10:
                if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if(!item.ControlValue)
              {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
      });

      if (isValid) {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (inactiveValueControls && inactiveValueControls.length > 0) {
          isValid = false;
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }
    }
    else {
      // Check at least one field value exists
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter at least one field. <br/>`;
      }
    }

      if (!isValid)
        this.commonService.ValidationBanner(message);
    return isValid;
  }

  validateDelControls(): boolean {
    let isValid = true;
    let message = "";
    var formData = this["self"].deliveryFormatForm.value;

    if (
      formData.THERAPEUTIC_AREA_ID === null ||
      formData.THERAPEUTIC_AREA_ID === "" ||
      formData.THERAPEUTIC_AREA_ID === undefined
    ) {
      $("#THERAPEUTIC_AREA_ID").addClass(
        "ng-touched ng-invalid validate-error"
      );
      $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
      message += "Please enter Therapeutic Area<br/>";
      isValid = false;
    } else {
      $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
      $("#THERAPEUTIC_AREA_ID").removeClass(
        "ng-touched ng-invalid validate-error"
      );
    }

    if (
      formData.FORMAT_TYPE_ID === null ||
      formData.FORMAT_TYPE_ID === "" ||
      formData.FORMAT_TYPE_ID === undefined
    ) {
      $("#FORMAT_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#FORMAT_TYPE_ID").removeClass("ng-untouched ng-valid");
      message += "Please enter Delivery Format Type<br/>";
      isValid = false;
    } else {
      $("#FORMAT_TYPE_ID").addClass("ng-untouched ng-valid");
      $("#FORMAT_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      return isValid;
  }

  NavigateToGenInfo() {
    this.appid = this.commonService.appId;
    let MenuModule = this.commonService.getModuleMenu();
    if (this.appid == null || this.appid == undefined || this.appid == "") {
      const modalRefAcc = this.modalService.open(MessageBoxComponent, {});
      modalRefAcc.componentInstance.Content = {
        heading: "",
        content: {
          heading: "",
          description:
            "Please save General information details to navigate to Delivery Format",
          operation: { hasConfirm: false },
        },
      };
      modalRefAcc.result.then((result) => {
        this.router.navigate(
          [
            "/home/grants/my-applications/application-ext/:" +
            0 +
            "/geninfocme",
          ],
          {
            skipLocationChange: true,
            queryParams: {
              id: 0,
              app_ext: true,
              module: "grants",
              submodule: MenuModule.module,
              screen_type: "my-applications",
            },
          }
        );
      });
      return false;
    }
  }
  // canExit() {
  //   if (this.deliveryFormatForm.dirty || this.extendedForm.IsFormToched) {
  //     return this.commonService.CanDeactivateBanner();
  //   }
  //   else {
  //     return Promise.resolve(true);
  //   }
  // }
  canExit() {
    if (this.IsFormToched && this.permission == 'Edit') {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");

    if(question.FIELD_CODE == 'FORMAT_TYPE_ID'){
      this.staticformFields.forEach(x=>{
        if(question.ControlValue == "web"){
          if(x.FIELD_CODE == 'WEB_FACULTIES_CNT' || x.FIELD_CODE == 'WEB_START_DATE' || x.FIELD_CODE == 'WEB_END_DATE' || x.FIELD_CODE == 'WEB_URL'){
            x.IS_Dependent_Display = true;
          }
          if(x.FIELD_CODE == 'IS_OPT_IN_PROCESS' || x.FIELD_CODE == 'RELEASE_DATE' || x.FIELD_CODE == 'EXPIRY_DATE' ||
          x.FIELD_CODE == 'TRANSFER_MODE' || x.FIELD_CODE == 'LIVE_FACULTIES_CNT' || x.FIELD_CODE == 'LIVE_START_DATE' ||
          x.FIELD_CODE == 'LIVE_END_DATE' || x.FIELD_CODE == 'LIVE_ADDRESS'){
            x.IS_Dependent_Display = false;
          }
        }
        if(question.ControlValue == "live"){
          if(x.FIELD_CODE == 'LIVE_FACULTIES_CNT' || x.FIELD_CODE == 'LIVE_START_DATE' || x.FIELD_CODE == 'LIVE_END_DATE' || x.FIELD_CODE == 'LIVE_ADDRESS'){
            x.IS_Dependent_Display = true;
          }
          if(x.FIELD_CODE == 'IS_OPT_IN_PROCESS' || x.FIELD_CODE == 'RELEASE_DATE' || x.FIELD_CODE == 'EXPIRY_DATE' ||
          x.FIELD_CODE == 'TRANSFER_MODE' || x.FIELD_CODE == 'WEB_FACULTIES_CNT' || x.FIELD_CODE == 'WEB_START_DATE' || 
          x.FIELD_CODE == 'WEB_END_DATE' || x.FIELD_CODE == 'WEB_URL'){
            x.IS_Dependent_Display = false;
          }
        }
        if(question.ControlValue == "enduring_material"){
          if(x.FIELD_CODE == 'IS_OPT_IN_PROCESS' || x.FIELD_CODE == 'RELEASE_DATE' || x.FIELD_CODE == 'EXPIRY_DATE' || x.FIELD_CODE == 'TRANSFER_MODE'){
            x.IS_Dependent_Display = true;
          }
          if(x.FIELD_CODE == 'WEB_FACULTIES_CNT' || x.FIELD_CODE == 'WEB_START_DATE' || 
             x.FIELD_CODE == 'WEB_END_DATE' || x.FIELD_CODE == 'WEB_URL' || x.FIELD_CODE == 'LIVE_FACULTIES_CNT' || 
             x.FIELD_CODE == 'LIVE_START_DATE' || x.FIELD_CODE == 'LIVE_END_DATE' || x.FIELD_CODE == 'LIVE_ADDRESS'){
            x.IS_Dependent_Display = false;
          }
        }
        if(question.ControlValue == "" || question.ControlValue == null || question.ControlValue == undefined){
          if(x.FIELD_CODE == 'WEB_FACULTIES_CNT' || x.FIELD_CODE == 'WEB_START_DATE' || 
             x.FIELD_CODE == 'WEB_END_DATE' || x.FIELD_CODE == 'WEB_URL' || x.FIELD_CODE == 'LIVE_FACULTIES_CNT' || 
             x.FIELD_CODE == 'LIVE_START_DATE' || x.FIELD_CODE == 'LIVE_END_DATE' || x.FIELD_CODE == 'LIVE_ADDRESS' || 
             x.FIELD_CODE == 'IS_OPT_IN_PROCESS' || x.FIELD_CODE == 'RELEASE_DATE' || x.FIELD_CODE == 'EXPIRY_DATE' || x.FIELD_CODE == 'TRANSFER_MODE'){
            x.IS_Dependent_Display = false;
          }
        }
      })
    }

  }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    let Flag = true;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 52428800) || (ext == 'exe'))) {
        Flag = false;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (!Flag)
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  BindDataToStaticControls(MainObjData: any): any {
    for (var i = 0; i < this.staticformFields.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "THERAPEUTIC_AREA_ID":
          this.staticformFields[i].ControlValue = MainObjData.THERAPEUTIC_AREA_ID;
          break;
        case "FORMAT_TYPE_ID":
          this.staticformFields[i].ControlValue = MainObjData.FORMAT_TYPE_ID;
          break;
        case "MEETING_TYPE_ID":
          this.staticformFields[i].ControlValue = MainObjData.MEETING_TYPE_ID;
          break;
        case "LIVE_FACULTIES_CNT":
          this.staticformFields[i].ControlValue = MainObjData.LIVE?.NO_OF_FACULTIES;
          if(MainObjData.FORMAT_TYPE_ID == 'live'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "LIVE_START_DATE":
          if(MainObjData.LIVE?.START_DATE != null && MainObjData.LIVE?.START_DATE != undefined && MainObjData.LIVE?.START_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.LIVE.START_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'live'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "LIVE_END_DATE":
          if(MainObjData.LIVE?.END_DATE != null && MainObjData.LIVE?.END_DATE != undefined && MainObjData.LIVE?.END_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.LIVE.END_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'live'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "LIVE_ADDRESS":
          this.staticformFields[i].ControlValue = MainObjData.LIVE?.ADDRESS;
          if(MainObjData.FORMAT_TYPE_ID == 'live'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "WEB_FACULTIES_CNT":
          this.staticformFields[i].ControlValue = MainObjData.WEB?.NO_OF_FACULTIES;
          if(MainObjData.FORMAT_TYPE_ID == 'web'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "WEB_START_DATE":
          if(MainObjData.WEB?.START_DATE != null && MainObjData.WEB?.START_DATE != undefined && MainObjData.WEB?.START_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.WEB.START_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'web'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "WEB_END_DATE":
          if(MainObjData.WEB?.END_DATE != null && MainObjData.WEB?.END_DATE != undefined && MainObjData.WEB?.END_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.WEB.END_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'web'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "WEB_URL":
          this.staticformFields[i].ControlValue = MainObjData.WEB?.WEB_URL;
          if(MainObjData.FORMAT_TYPE_ID == 'web'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "IS_OPT_IN_PROCESS":
          if(MainObjData.FORMAT_TYPE_ID == 'enduring_material'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          this.staticformFields[i].ControlValue = MainObjData.ENDURING_MATERIAL?.IS_OPT_IN_PROCESS;
          break;
        case "RELEASE_DATE":
          if(MainObjData.ENDURING_MATERIAL?.RELEASE_DATE != null && MainObjData.ENDURING_MATERIAL?.RELEASE_DATE != undefined && MainObjData.ENDURING_MATERIAL?.RELEASE_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.ENDURING_MATERIAL.RELEASE_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'enduring_material'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "EXPIRY_DATE":
          if(MainObjData.ENDURING_MATERIAL?.EXPIRY_DATE != null && MainObjData.ENDURING_MATERIAL?.EXPIRY_DATE != undefined && MainObjData.ENDURING_MATERIAL?.EXPIRY_DATE != ''){
            this.staticformFields[i].ControlValue = new Date(MainObjData.ENDURING_MATERIAL.EXPIRY_DATE);
          }
          if(MainObjData.FORMAT_TYPE_ID == 'enduring_material'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          break;
        case "TRANSFER_MODE":
          if(MainObjData.FORMAT_TYPE_ID == 'enduring_material'){
            this.staticformFields[i].IS_Dependent_Display = true;
          }
          this.staticformFields[i].ControlValue = MainObjData.ENDURING_MATERIAL?.TRANSFER_MODE;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }
  }

  BindDataToDynamicControls() {
    if (this.appid != null && this.appid != undefined && this.appid != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-024";
      sr.RowId = this.appid;
      sr.AppId = this.appid;
      this.summaryService.getGrantsScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }

  getScreenDataEdit(){
    this.summaryService
    .getDeliveryFormatSummary(this.Grantsapp?.ID == undefined ? '' : this.Grantsapp?.ID,this.appid).subscribe((summary) => {
      if (summary != null && summary != undefined) {

        this.createdUser = summary["CREATED_BY"];
        //this.permission = summary["PERMISSION"];
        if(summary["ID"] == null){
          this.submitStatus = true;
        }

        if(((this.user.ID != summary["CREATED_BY"]) && summary["SUBMIT_STATUS"] == 1 ) || (this.user.ID == summary["CREATED_BY"]) || this.isSubmitVisible == false ){
          this.Id = summary["ID"];
          this.status = summary["STATUS"];
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(summary);
          this.ScreenSubmitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
          this.submitStatus = true;
        } 
        else{
          this.submitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
        }
        if(this.Grantsapp?.STATUS > 1 && summary["SUBMIT_STATUS"] == 1){
          this.disableSave = true;
        }

        if(!this.isSubmitVisible){
          this.disableSave = false;
        }
      }
    });
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.appid, this.appid,(ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];

      this.staticformFields.forEach(x=>{
        if(x.FIELD_CODE == 'IS_OPT_IN_PROCESS' || x.FIELD_CODE == 'RELEASE_DATE' || x.FIELD_CODE == 'EXPIRY_DATE' ||
           x.FIELD_CODE == 'TRANSFER_MODE' || x.FIELD_CODE == 'LIVE_FACULTIES_CNT' || x.FIELD_CODE == 'LIVE_START_DATE' ||
           x.FIELD_CODE == 'LIVE_END_DATE' || x.FIELD_CODE == 'LIVE_ADDRESS' || x.FIELD_CODE == 'WEB_FACULTIES_CNT' ||
           x.FIELD_CODE == 'WEB_START_DATE' || x.FIELD_CODE == 'WEB_END_DATE' || x.FIELD_CODE == 'WEB_URL'
        ){
          x.IS_Dependent_Display = false;
        }
      })
      this.ScreenName = ScreenData.NAME;
      this.getScreenDataEdit();
      if(this.Grantsapp?.STATUS > 1 ){
        this.isSubmitVisible = ScreenData.HAS_SAVE_SUBMIT == 1 ? true :false;       
      }  
    });
  }

  SaveCME_GM_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.GeneralInformationFields));
    uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
    uploadData.append("SUBMIT_STATUS","0");
     uploadData.append("Currency_ID",this.Currency_ID);
    return this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Insert", uploadData);
  }

  GetParentScreenFieldsConfigControls(screenCode: string)
  {
    this.commonService.GetScreenConfigControls(screenCode, this.appid, this.appid, (ScreenData) => {
      this.GeneralInformationFields = ScreenData["SCREEN_CONTROL"];
    });
  }

}
